<template>
<main class="sa-content">
    <notific-msg />
</main>
</template>

<script>
import NotificMsg from '../../components/notification/NotificMsg.vue';
export default {
  components: { NotificMsg },
    data() {
        return {
        };
    }
};
</script>
